import CacheMan from "../jslibs/CacheMan";
import GError from "../jslibs/GError";
import Meals, { IMeal } from "../shared/Meals";
import FoodApi from "./FoodApi";
import { ICache } from "./ICache";

export default class MealsCache extends CacheMan<string, Meals> implements ICache<IMeal> {
    static _i:MealsCache
    static get i(){
        if (!this._i) this._i = new MealsCache("meals", 3600)
        return this._i
    }
    async fetch(userId:string): Promise<Meals> {
        return new Meals(userId, await FoodApi.i.meals())
    }
    async fetchBatch(keys: string[]): Promise<Meals[]> {
        throw "Not implemented"
    }
    async getMeals(){
        if (!FoodApi.i.userId) throw new GError.NotAuthorized()
        return this.get(FoodApi.i.userId)
    }
    async addMeal(name:string){
        const meals = await this.getMeals()
        const meal = await FoodApi.i.addMeal(name)
        meals.update(meal)
        this.add(meals.userId, meals.update(meal))
        return meal
    }
    async updateItem(id:string,data:Partial<IMeal>){
        const meals = await this.getMeals()
        const meal = await FoodApi.i.updateMeal(id, data)
        meals.update(meal)
        this.add(meals.userId, meals.update(meal))
        return meal
    }
    async removeItem(id:string){
        const meals = await this.getMeals()
        await FoodApi.i.removeMeal(id)
        meals.deleteKey(id)
        this.add(meals.userId, meals)
    }
    async getItem(id: string) {
        return this.getMeals().then(all => all.find(id)!)
    }
    itemId(item:IMeal) { return item._id}
    itemName(item:IMeal) { return item.name} 
}
